import { ErrorMessage } from "formik";
import React from "react";

export default function Checkbox({ field, form: { setFieldValue }, ...props }) {
  return (
    <div className={"form-group col-md-" + (props.colNumber || 4)}>
      <label className="text-black font-w600">
        {props.required ? "*" : ""}
        {props.label}
      </label>

      <div className="custom-control custom-checkbox mb-3">
        <input
          type="checkbox"
          className="custom-control-input"
          defaultChecked={props.value}
          id={field.name}
          value={field.value}
          onClick={(e) => {
            if (props.onChangeFunc) {
              props.onChangeFunc(e.target.checked, setFieldValue);
            }
          }}
          {...field}
          {...props}
        />
        <label className="custom-control-label" htmlFor={field.name}>
          {props.checkboxText}
        </label>
      </div>
      <ErrorMessage
        name={field.name}
        render={(msg) => (
          <span className="text-danger">
            <small>*{msg}</small>
          </span>
        )}
      />
    </div>
  );
}
